<div class="row">
    <div class="col-12">
        <div class="float-end">
            <button class="btn btn-link" (click)="expandAll()" translate="F4M_RENDERER_EXPAND_CHECKPOINTS"></button>
            <button class="btn btn-link" (click)="collapseAll()" translate="F4M_RENDERER_COLLAPSE_CHECKPOINTS"></button>
        </div>
    </div>
    @if ((isLoading$ | async) === false) {
        <form class="col-12 form-content" [formGroup]="paceFormsGroup">
            @if ((notServicePartQuestionnaire$ | async) === false) {
                <pace-forms-accordion
                    group="section-defectServicePartIdentification"
                    [open]="defectServicePartIdentificationOpen"
                    data-[accordionInvalid]="(isDefectServicePartIdentificationInvalid$ | async)"
                    [accordionInvalid]="defectServicePartIdentificationChildren.invalid"
                    (openChange)="defectServicePartIdentificationOpenChanged($event)"
                >
                    <ng-template #heading>
                        <div>{{ defectServicePartIdentificationHeading$ | async }}</div>
                    </ng-template>
                    <ng-template #body>
                        <div>
                            <pace-forms-defect-service-part-identification
                                [parentForm]="defectServicePartIdentificationChildren"
                            ></pace-forms-defect-service-part-identification>
                        </div>
                    </ng-template>

                    <ng-template #closer>
                        <div role="link" translate="F4M_RENDERER_FRONT_MATTER"></div>
                    </ng-template>
                </pace-forms-accordion>
            }
            @if (notServicePartQuestionnaire$ | async) {
                <pace-forms-accordion
                    group="customerIdentification"
                    [open]="customerIdentificationOpen"
                    (openChange)="customerIdentificationOpenChanged($event)"
                >
                    <ng-template #heading>
                        <div>{{ customerInformationHeading$ | async }}</div>
                    </ng-template>
                    <ng-template #body>
                        <div>
                            <pace-forms-customer-identification
                                [parentForm]="paceFormsChildren"
                            ></pace-forms-customer-identification>
                        </div>
                    </ng-template>
                    <ng-template #closer>
                        <div role="link" translate="F4M_RENDERER_FRONT_MATTER"></div>
                    </ng-template>
                </pace-forms-accordion>
            }

            @if (displayHintsForFilling$ | async) {
                <pace-forms-accordion
                    group="hintsforfilling"
                    [open]="hintsForFillingOpen"
                    (openChange)="hintsForFillingOpenChanged($event)"
                >
                    <ng-template #heading>
                        <div>{{ (hintsForFilling$ | async)?.heading }}</div>
                    </ng-template>
                    <ng-template #body>
                        <div>
                            <pace-forms-hints-for-filling></pace-forms-hints-for-filling>
                        </div>
                    </ng-template>
                    <ng-template #closer>
                        <div role="link">Close "{{ (hintsForFilling$ | async)?.heading }}"</div>
                    </ng-template>
                </pace-forms-accordion>
            }
            <ng-container *ngrxLet="remarksSection$ as remarksSection">
                @if (remarksSection) {
                    <pace-forms-accordion
                        group="remarksGroup"
                        [open]="remarksSectionOpen"
                        (openChange)="remarksSectionOpenChanged($event)"
                    >
                        <ng-template #heading>
                            <div>{{ remarksSection.title }}</div>
                        </ng-template>
                        <ng-template #body>
                            <pace-forms-input-text
                                [id]="remarksSection.remarksXmlId"
                                [label]="remarksSection.remarksXmlLabel"
                                [formControl]="remarksSectionControl"
                            ></pace-forms-input-text>
                        </ng-template>
                        <ng-template #closer>
                            <div role="link" translate="F4M_RENDERER_FRONT_REMARKS_SECTION"></div>
                        </ng-template>
                    </pace-forms-accordion>
                }
            </ng-container>
            <ng-container *ngrxLet="measurementEquipments$ | async as measuringEquipment">
                @if (measuringEquipment?.visibility) {
                    <pace-forms-measurement-equipments></pace-forms-measurement-equipments>
                }
            </ng-container>
            @for (content of content$ | async; track trackByFn($index, content)) {
                <pace-content-renderer
                    [contentId]="content.id"
                    [parentForm]="paceFormsChildren"
                ></pace-content-renderer>
            }
            @if (displaySystemCondition$ | async) {
                <pace-forms-accordion
                    group="section-systemcondition"
                    [accordionInvalid]="isSystemConditionValid$ | async"
                    [open]="systemConditionOpen"
                    (openChange)="systemConditionOpenChanged($event)"
                >
                    <ng-template #heading>
                        <div>{{ (systemCondition$ | async)?.heading }}</div>
                    </ng-template>
                    <ng-template #body>
                        <div>
                            <pace-forms-system-condition
                                [parentForm]="systemConditionChildren"
                            ></pace-forms-system-condition>
                        </div>
                    </ng-template>
                    <ng-template #closer>
                        <div role="link">Close "{{ (systemCondition$ | async)?.heading }}"</div>
                    </ng-template>
                </pace-forms-accordion>
            }
            @if (isMockMode) {
                <pace-forms-accordion
                    group="XmlView"
                    [open]="xmlViewerOpen"
                    (openChange)="xmlViewerOpenChanged($event)"
                >
                    <ng-template #heading>
                        <div translate="F4M_RENDERER_XML_VIEWER"></div>
                    </ng-template>
                    <ng-template #body>
                        <div>
                            <pace-forms-xml-renderer></pace-forms-xml-renderer>
                        </div>
                    </ng-template>
                    <ng-template #closer>
                        <div role="link" translate="F4M_RENDERER_CLOSE_XML_VIEWER"></div>
                    </ng-template>
                </pace-forms-accordion>
            }
        </form>
    }
    <div class="col-12">
        <div class="float-end">
            <button class="btn btn-link" (click)="expandAll()" translate="F4M_RENDERER_EXPAND_CHECKPOINTS"></button>
            <button class="btn btn-link" (click)="collapseAll()" translate="F4M_RENDERER_COLLAPSE_CHECKPOINTS"></button>
        </div>
    </div>
    @if ((form$ | async).isLoading) {
        <div class="col-12 form-content">
            <div class="card">
                <div class="card-body">
                    <progressbar
                        type="default"
                        [striped]="true"
                        [value]="100"
                        translate="F4M_RENDERER_CONTENT_LOADING_LABEL"
                    ></progressbar>
                </div>
            </div>
        </div>
    }
</div>
